import React from "react";
import profileImage from "../assets/Profile/profileImage.jpg"; // Fallback image

function Header({ profilePhoto, name, description }) {
  return (
    <header className="py-2 flex flex-col items-center space-x-8">
      <div>
        <img
          src={profilePhoto || profileImage}
          alt={`${name || "Abdul Wadood"} - Software Developer Profile`}
          className="border-4 border-transparent bg-gradient-to-r from-black via-black to-blue-500 p-1 w-[200px] sm:w-[300px] h-[200px] sm:h-[300px] mb-4 object-cover"
          onError={(e) => {
            // Fallback to default image if the fetched image fails to load
            e.target.src = profileImage;
          }}
          loading="eager"
          width="300"
          height="300"
        />
      </div>
      <div className="text-left">
        <div className="sm:text-5xl text-3xl">
          <h1 className="font-bold dark:text-white">
            Hi{" "}
            <span role="img" aria-label="wave">
              👋
            </span>
            , 
          </h1>
          <h1 className="font-bold dark:text-white">
            My name is <span className="text-blue-500">{name || "Abdul Wadood"}</span>
          </h1>
        </div>
        <p className="text-2xl mt-2 font-semibold text-gray-700 dark:text-white">
          {description || "I'm a software developer with a passion for building innovative solutions."}
        </p>
      </div>
    </header>
  );
}

export default Header;
